// extracted by mini-css-extract-plugin
module.exports = {"SaveElectricF":"F_SaveElectricF__Q9Z6t"};